// extracted by mini-css-extract-plugin
export default {"container":"Social_container__zOWZ8","link":"Social_link__haLGa"};